import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowCircleUp = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4 20c0-8.839 7.161-16 16-16s16 7.161 16 16-7.161 16-16 16S4 28.839 4 20Zm9.264 1.864 4.672-4.87v11.78c0 .858.69 1.549 1.548 1.549h1.032c.858 0 1.549-.69 1.549-1.549v-11.78l4.67 4.87c.6.626 1.6.64 2.213.026l.704-.71a1.542 1.542 0 0 0 0-2.186l-8.555-8.562a1.542 1.542 0 0 0-2.187 0l-8.568 8.562a1.542 1.542 0 0 0 0 2.187l.703.71c.62.612 1.62.6 2.22-.026Z" })
});
export default SvgArrowCircleUp;
